/* global YT */
import $ from 'jquery';
import SweetScroll from 'sweet-scroll';
import BaseComponent from './baseComponent';

/**
 * Component that implements the video functionality.
 */
export default class Video extends BaseComponent {
  /**
     * Public constructor
     *
     * @param {object} options
     */
  constructor(options) {
    super(options);
    this.sweetScroll = null;
    this.videoElements = null;
    window.youtubePlayers = {};
    this.youtubePlayerIsReady = false;
    return this;
  }

  /**
     * Initialize function
     */
  init() {
    this.videoElements = $('[data-video-thumbnail]');
    this.sweetScroll = new SweetScroll();

    // Only initialize youtube api scripts if there are actually video elements
    if (this.videoElements.length > 0) {
      this.initYoutubeScript();
    }

    this.videoElements.each((key, item) => {
      const $video = $(item);
      const videoData = this.getVideoData($video);

      if (videoData.hasThumbnail) {
        // do nothing
      } else if (videoData.isYouTube) {
        // do nothing
      } else if (videoData.isVimeo) {
        Video.placeVimeoImage($video, videoData);
      } else {
        Video.placePlaceHolder($video);
      }

      if (!videoData.isYouTube) {
        $video.on('click', videoData, Video.playDefaultVideo);
      }
    });
  }

  prepareYoutubeVideos() {
    const self = this;
    this.videoElements.each((key, item) => {
      const $video = $(item);
      const videoData = this.getVideoData($video);

      if (videoData.isYouTube) {
        Video.placeYouTubeImage($video, videoData);
        Video.initYouTubeVideo($video, videoData, self);

        if (!$video.data('youtube-click-event-set')) {
          // @see https://codepen.io/chriscoyier/pen/zawHg
          item.addEventListener('click', (event) => {
            event.preventDefault();

            const thumbnail = $(event.target).parents('.video-thumbnail');
            const player = $(thumbnail).next('.video-player');
            const id = $(player)
              .find('iframe')
              .attr('id');

            self.playYouTubeVideo($(thumbnail), $(player), id, self);
            window.youtubePlayers[id].playVideo();
          });
          $video.data('youtube-click-event-set', true);
        }
      }
    });
  }

  /**
     * Add the Youtube Api Script.
     */
  initYoutubeScript() {
    const youtubeScriptId = 'youtube-api';
    const youtubeScript = document.getElementById(youtubeScriptId);

    if (youtubeScript === null) {
      const tag = document.createElement('script');

      tag.src = 'https://www.youtube.com/iframe_api';
      tag.id = youtubeScriptId;
      $('body').append(tag);
    }

    if (typeof YT === 'undefined' || !this.youtubePlayerIsReady) {
      window.onYouTubePlayerAPIReady = () => {
        this.youtubePlayerIsReady = true;
        this.prepareYoutubeVideos();
      };
    } else if (this.youtubePlayerIsReady) {
      this.prepareYoutubeVideos();
    }
  }

  /**
     * Retrieves information about video object
     *
     * @param $videoItem
     * @returns {object}
     */
  getVideoData($videoItem) {
    const videoData = { };
    videoData.$video = $videoItem.next('[data-video]');
    videoData.$iframe = videoData.$video.find('iframe');
    videoData.isIFrame = videoData.$iframe.length === 1;
    videoData.hasThumbnail = $videoItem.find('img').length > 0;
    videoData.scroller = this.sweetScroll;

    if (videoData.isIFrame) {
      videoData.src = videoData.$iframe.attr('src');
      videoData.isYouTube = videoData.src.indexOf('youtube') !== -1;
      videoData.isVimeo = videoData.src.indexOf('vimeo') !== -1;
    }

    return videoData;
  }

  /**
     * Plays the video
     *
     * @param {object} event
     */
  static playDefaultVideo(event) {
    event.preventDefault();

    $(event.currentTarget).fadeOut('slow', () => {
      if (event.data.isVimeo) {
        const src = event.data.src.replace('autoplay=0', 'autoplay=1');
        event.data.$iframe.attr('src', src);
      } else {
        const $videoPlayers = event.data.$video.find('video');
        if ($videoPlayers.length > 0) {
          window._mtm = window._mtm || []; // eslint-disable-line no-underscore-dangle

          const videoTitle = event.data.$video.find('p').text();
          const videoUrl = `${window.location.protocol}//${window.location.host}${event.data.$video.find('source').attr('src')}`;

          window._mtm.push({ // eslint-disable-line no-underscore-dangle
            event: 'playVideo',
            'dlv-videoTitle': videoTitle,
            'dlv-videoUrl': videoUrl, // Optional
          });

          $videoPlayers[0].play();
        }
      }
      event.data.$video.css('display', 'block');
      event.data.scroller.toElement(event.data.$video[0], { offset: -100 });
    });
  }

  /**
     * Plays the youtube video.
     * @param $thumbnail
     * @param $video
     * @param id
     */
    playYouTubeVideo($thumbnail, $video, id, self) { // eslint-disable-line
    $thumbnail.fadeOut('slow', () => {
      $video.css('display', 'block');
      self.sweetScroll.toElement($video[0], { offset: -100 });
    });
  }

  static initYouTubeVideo($item, videoData, self) {
    // Check if video is initialized already:
    const idToCheck = videoData.$iframe.attr('id');
    if (idToCheck && window.youtubePlayers[idToCheck]) {
      return;
    }

    let id = videoData.src.replace('https://www.youtube.com/embed/', 0).split('?')[0];
    const { src } = videoData;
    const srcParameterSplit = src.split('?');
    const srcWithoutParameter = srcParameterSplit[0];
    let srcParameterString = '';
    if (srcParameterSplit.length > 1) {
      [srcParameterString] = srcParameterSplit;
    }
    const srcParameterDataRaw = srcParameterString.split('&');
    const srcParameterData = {};
    const currentUrl = `${window.location.protocol}//${window.location.hostname}`;

    $.each(srcParameterDataRaw, (index, dataRaw) => {
      const data = dataRaw.split('=');
      // eslint-disable-next-line prefer-destructuring
      srcParameterData[data[0]] = data[1];
    });

    // Add own data to the source-parameters:
    srcParameterData.enablejsapi = 1;
    srcParameterData.modestbranding = 0;
    srcParameterData.rel = 0;
    srcParameterData.showinfo = 0;
    srcParameterData.html5 = 1;
    srcParameterData.vq = 'hd1080';
    srcParameterData.origin = currentUrl;

    const addons = Object.keys(srcParameterData)
      .map((key) => `${key}=${srcParameterData[key]}`)
      .join('&');

    id += self.randomStringGenerator(10);

    videoData.$iframe.attr('id', id);
    videoData.$iframe.attr('src', `${srcWithoutParameter}?${addons}`);
    window.youtubePlayers[id] = new YT.Player(id, {
      suggestedQuality: 'hd1080',
      events: {
        playerVars: {
          enablejsapi: 1, modestbranding: 0, rel: 0, showinfo: 0, html5: 1, origin: currentUrl,
        },
        onReady: (event) => {
          event.target.setPlaybackQuality('hd1080');
          $('.media.-hidden').removeClass('-hidden');
        },
        onStateChange: (event) => {
          if (event.data === YT.PlayerState.BUFFERING) {
            event.target.setPlaybackQuality('hd1080');
          }
        },
        onError: (a, b, c) => {
          console.log('error on loading a youtube player');
          console.log(a);
          console.log(b);
          console.log(c);
        },
      },
    });
  }

  /**
     * Places image by youtube embed url
     *
     * @param $item
     * @param {object} videoData
     */
  static placeYouTubeImage($item, videoData) {
    const matches = /youtube[.]com\/(v|embed)\/([^"?]+)/g.exec(videoData.src);

    if (matches.length === 3 && matches[2]) {
      if ($item.find('img').length < 1) {
        Video.placeImage($item, `https://img.youtube.com/vi/${matches[2]}/maxresdefault.jpg`);
      }
    } else {
      Video.placePlaceHolder($item);
    }
  }

  /**
     * Places image by vimeo embed url
     *
     * @param $item
     * @param {object} videoData
     */
  static placeVimeoImage($item, videoData) {
    const matches = /vimeo[.]com\/(v|video)\/([^"?]+)/g.exec(videoData.src);

    if (matches.length === 3 && matches[2]) {
      $.getJSON(
        `https://vimeo.com/api/v2/video/${matches[2]}.json`,
        (data) => {
          if (data.length > 0) {
            Video.placeImage(
              $item,
              data[0].thumbnail_large,
            );
          }
        },
      ).fail(() => {
        Video.placePlaceHolder($item);
      });
    } else {
      Video.placePlaceHolder($item);
    }
  }

  /**
     * Renders an image by src
     *
     * @param $item
     * @param {string} src
     */
  static placeImage($item, src) {
    $item.append(
      `<img src="${src}" class="image" />`,
    );
  }

  /**
     * places a placeholder if no image provided or found
     *
     * @param $item
     */
  static placePlaceHolder($item) {
    $item.append(
      '<div class="placeholder"></div>',
    );
  }

  randomStringGenerator(length) { // eslint-disable-line class-methods-use-this
    const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const randomArray = [];
    for (let i = 0; i < length; i += 1) {
      const randomPos = Math.floor(Math.random() * charSet.length);
      randomArray.push(charSet.substring(randomPos, randomPos + 1));
    }
    return randomArray.join('');
  }
}
